var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g({staticClass:"py-2 px-4 text-sm text-gray-800 dark:text-gray-400 border border-gray-400 dark:border-gray-700 hover:bg-gray-300 dark-hover:bg-gray-800 focus:outline-none rounded",class:{
    'bg-gray-300 dark:bg-gray-800': _vm.selected,
    'bg-white dark:bg-gray-900': !_vm.selected
  }},_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }